import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { ActionState, BaseComponentConfig, ComponentConfig, ComponentTask, Relation, SelectedValue, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { map } from 'rxjs';
import { imageOptions } from '../configoptions';

@Component({
  selector: 'ubs-product-images',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./product-images.component.scss']
})
export class ProductImagesComponent extends BaseComponentConfig implements OnInit { 
  productId:string;
   @Output() contextMenuItems = new EventEmitter<NbMenuItem[]>()     

   defaultAction = ActionState.LIST;

   readonly routeParams$ = this.route.paramMap.pipe(map(params => params));

   constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    private http:HttpClient,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService) {
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService);
    this.routeParams$.subscribe(params => {
      if(params.get("productId")){
        this.productId = params.get("productId")
        console.log(this.productId)
        if(params.get('event')){
          this.action = this.setActionStateFromParam(params.get('event'))
          console.log(this.action);
        }
      }else{
        this.route.data.subscribe(data => {
          if(data.event){
            console.log("getting evet from route data",data.event);
            this.action = this.setActionStateFromParam(data.event);
            this.routerData = data;
          }
        });
      }    
    })
    /**
       * Handle menu clicks
       */
    this.menuService.onItemClick().subscribe((event) => {
      if(event.tag != 'contextMenu'){
        if(event.item.data){}
      }else if(event.tag == 'contextMenu'){
        if(event.item.data){
          let data = event.item.data;
          this.action = data.event;
          this.selectedValueType = data.type?data.type:this.setSelectedValueType(this.action);
        }
      }
    });
    /* this.route.paramMap.subscribe((params) => {
      this.routerParams = params;
      this.productId = params.get("productId");
      imageOptions.listForm.remoteFormData.parameters["productId"] = params.get("productId");
    }) */
    
   }
  
   ngOnInit(): void {
    if(this.productId != undefined && this.productId != null){
      if(this.action != null && this.action != undefined){
        this.selectedValueType = this.setSelectedValueType(this.action);
        if(this.action == ActionState.MASTERDETAIL || this.action == ActionState.RELATE){
          if(this.action == ActionState.MASTERDETAIL){
            console.log(this.action)
            imageOptions.selectedMasterDetails = this.setSelectedRelation(this.action,this.selectedValueType);
            console.log(this.selectedValueType,imageOptions.selectedMasterDetails)
          }
          if(this.action == ActionState.RELATE){
            imageOptions.selectedRelation = this.setSelectedRelation(this.action,this.selectedValueType);
          }
          //this.setListOption(this.action);
        }else if(this.action == ActionState.TASKSACTRSLT) {
          imageOptions.selectedTask = this.setSelectedTask (this.selectedValueType);
        }
      }
      this.setSelectedValue(this.productId);
      this.createMenuItems(this.productId);    
    }else{
      if(this.action == ActionState.LIST){
        console.log(imageOptions);
        imageOptions.listForm = imageOptions.listForm;
      }
    }
    //Create menu item for product
    
     
    this.baseUrl = this.getBaseUrl();
    let menuAndTitleOptions = this.componentConfig.getMenuAndTitleOptions();
    //this.menuService.addItems(items,"imageMenu");
    let listForm = this.componentConfig.listForm;
    console.log(listForm);
    imageOptions.defaultAction =  this.action?this.action:this.defaultAction;
    this.componentConfig = new ComponentConfig(imageOptions);
  }

  setSelectedValueType(action:ActionState):string{
    let selectedValueType;
    switch (action) {
      case ActionState.CUSTOM:
        
        break;
        case ActionState.MASTERDETAIL:
          if(this.router.url.includes('product-images')){
            selectedValueType = "Product Images";
          }                 
        break;
        case ActionState.RELATE:
          if(this.router.url.includes('product-image')){
            selectedValueType = "Add Images";
          } 
        break;
        case ActionState.TASKSACTRSLT:
        
        break;
        case ActionState.ADD:
        
        break;
    
      default:
        break;
    }
    return selectedValueType
  }

  setSelectedValue(productId:string){
        console.log(this.action);
        let selectedValue:SelectedValue = {
          event:this.action?this.action:ActionState.CUSTOM,
          type:this.selectedValueType?this.selectedValueType:"FacilityOverView",
          label:"Facility",
          data:{
            formData: {
              formName: 'EditProductRest',
              formLocation: 'component://kwikstore/widget/FacilityForms.xml',
            },
            parameters:{"productId":productId}
          }
    
        }
        setTimeout(() =>{
          console.log(this.action)
          imageOptions.defaultAction = this.action?this.action:ActionState.CUSTOM;
    
          //this.componentStore.updateComponentConfig(this.componentConfig);
          //console.log(this.componentConfig);
          this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
          //this.hasValue=true;
        },500)
        
      }

  setSelectedRelation(action,selectedValueType):Relation{
      let selectedRelation;
      switch (action) {
        case ActionState.MASTERDETAIL:
          let masterDetails:any[] = imageOptions.masterDetails;
          masterDetails.forEach((masterDetail:Relation,i) => {
            console.log(masterDetail.title,selectedValueType);
            if(masterDetail.title == selectedValueType){
              selectedRelation = masterDetail;
              selectedRelation.listForm.findParameters = [];
              selectedRelation.listForm.findParameters.push({"productId":this.productId});
              if(selectedValueType == "Product Images"){
                selectedRelation.listForm.findParameters.push({"productId":this.productId});
                //selectedRelation.listForm.findParameters.push({productId:"WebStoreWarehouse"});
                //selectedRelation.listDetail.findParameters = [{orderId:this.orderId},{productId:"WebStoreWarehouse"}];
              }
              if(selectedValueType == "Ship Group Items"){
                selectedRelation.listDetail.findParameters = [{productId:this.productId}];
              }
              if(selectedRelation.isDymanic){
                selectedRelation.dynamicAddForms.forEach(form => {
                  form.breadCrumbData.data.parameters.productId = this.productId;
                })
              }
            }
            console.log(selectedRelation);
        })
          break;
        case ActionState.RELATE:
          let relations:any[] = imageOptions.relations;
          relations.forEach((relation:Relation,i) => {
            console.log(relation.title,selectedValueType);
            if(relation.title == selectedValueType){
              selectedRelation = relation;
              selectedRelation.listForm.findParameters = [];
              selectedRelation.listForm.findParameters.push({"productId":this.productId});
            }
            console.log(selectedRelation);
          })
          break;
      }
      return selectedRelation;
    }

    setSelectedTask(selectedValueType){
      let selectedTask;
      let tasks:any[] = imageOptions.tasks;
        tasks.forEach((task:ComponentTask,i) => {
          console.log(task.title,selectedValueType);
          if(task.title == selectedValueType){
            selectedTask = task;
          }
        })
      return selectedTask
    }

    createMenuItems(productId:string){
      let menuItems:NbMenuItem[] = [
        {
          title:"Gallery For "+this.productId,
          link:'/admin/img/product-galleries/gallery/'+productId,
        },
        {
          title: 'List Product Images',
          link:'/admin/img/product-galleries/gallery/product-images/'+productId+'/master-detail',
          icon:'image-outline',
          data:{
            event:"master-detail",
            type:"Product Images"
          }
        },
        {
          title:"Upload Additional Images",
          link:'/admin/img/product-galleries/gallery/product-image/'+productId+'/relate',
          icon:"cloud-upload-outline",
          data:{
            event:"relate",
            type:"Add Images",
            data:{
              formData:{
                formName:"AddProductImage",
                formLocation:"component://kwikstore/widget/ImageManagementForms.xml",
              },
              appContext:"kwikstore",
              parameters:{productId:productId}
            } 
            /* ,
            data:{
            formData:{
                formName:"ListProductCategoryMembers",
                formLocation:"component://kwikstore/widget/ImageManagementForms.xml"
            },
            appContext:"catalog",
            } */
          }
        },
        {
            title:"Manage Images",
            link:'/admin/img/product-galleries/gallery/'+productId+'/manage',
            icon:"settings-outline",
            data:{
              event:"relate",
              type:"Manage Product Images"
            }
        },
        {
            title:"Replace Images",
            link:'',
            icon:"refresh-outline"
        },
        {
            title:"Resize Images",
            link:'',
            icon:"crop-outline"
        }
      ]
      setTimeout(() =>{
        this.contextMenuItems.emit(menuItems)
      },1) 
    }
}
